import { render, staticRenderFns } from "./ChooseTopic.vue?vue&type=template&id=3d75c0b8"
import script from "./ChooseTopic.vue?vue&type=script&lang=js"
export * from "./ChooseTopic.vue?vue&type=script&lang=js"
import style0 from "./ChooseTopic.vue?vue&type=style&index=0&id=3d75c0b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports